import request from '@/utils/request'

// 新增小微企业成长服务-小微企业融资需求申请
export function addRzsqsx(data) {
  return request({
    url: '/web/xwqy/rzsqsx',
    method: 'post',
    data: data
  })
}


// 修改小微企业成长服务-小微企业融资需求申请
export function updateRzsqsx(data) {
  return request({
    url: '/web/xwqy/updateRzsqsx',

    method: 'post',
    data: data
  })
}

// 查询小微企业成长服务-小微企业融资需求申请详细
export function getRzsqsx(recid) {
  return request({
    url: '/web/xwqy/rzsqsx/' + recid,
    method: 'get'
  })
}

//获取企业的档案信息
export function getEntInfo(ywFwjgRecid) {
  return request({
    url: '/web/xwqy/getEntInfo/' + ywFwjgRecid,
    method: 'get'
  })
}